<template>
    <div class="d-flex pt-2">
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <div class="d-inline" v-on="on">
                    <icon-button @click="$emit('chooseTemplate')">
                        mdi-text-box
                    </icon-button>
                </div>
            </template>
            <span>{{ $t("Add template") }}</span>
        </v-tooltip>
        <v-tooltip v-if="!isAutomation && canAddAutomation" bottom>
            <template v-slot:activator="{ on }">
                <div class="d-inline" v-on="on">
                    <icon-button test-id="task-add-automation-trigger" @click="$emit('addAutomation')">
                        mdi-flash-outline
                    </icon-button>
                </div>
            </template>
            <span>{{ $t("Add automation") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <div class="d-inline" v-on="on">
                    <RichTextEditorPlaceholders
                        v-if="!isTemplate"
                        :company-id="companyId"
                        :placeholder-types="placeholderTypes"
                        :rich-text-editor="richTextEditor"
                        @placeholder="$emit('placeholder', $event)"
                        @placeholders="$emit('placeholders', $event)"
                    />
                </div>
            </template>
            <span>{{ $t("Add placeholder") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <div class="d-inline" v-on="on">
                    <RichTextEditorToolbar :id="toolbarId" />
                </div>
            </template>
            <span>{{ $t("Format text") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <div class="d-inline" v-on="on">
                    <icon-button @click="$emit('addAttachment')">
                        mdi-paperclip
                    </icon-button>
                </div>
            </template>
            <span>{{ $t("Add attachment") }}</span>
        </v-tooltip>
        <div class="ml-auto">
            <primary-button test-id="task-add-email-send" @click="$emit('send')">
                {{ saveText }}
            </primary-button>
        </div>
    </div>
</template>

<script>
import RichTextEditorToolbar from "../../../components/RichTextEditor/RichTextEditorToolbar";
import RichTextEditorPlaceholders from "../../../components/RichTextEditor/RichTextEditorPlaceholders";
import { $t } from "@/i18n";
import { computed } from "@vue/composition-api";

export default {
    name: "TaskAddEmailControlFooter",
    components: {
        RichTextEditorPlaceholders,
        RichTextEditorToolbar
    },
    props: {
        richTextEditor: {
            type: Object,
            default: null
        },
        isAutomation: {
            type: Boolean,
            required: true
        },
        isTemplate: {
            type: Boolean,
            required: true
        },
        isNewEmail: {
            type: Boolean,
            required: true
        },
        placeholderTypes: {
            type: Array,
            default: () => []
        },
        companyId: {
            type: Number,
            required: true
        },
        canAddAutomation: {
            type: Boolean,
            default: true
        },
        toolbarId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const saveText = computed(() => {
            if (!props.isAutomation) {
                return $t("Send")
            }

            return props.isNewEmail ? $t("Add automation") : $t("Save automation")
        })

        return {
            saveText
        }
    }
}
</script>

<style scoped>

</style>